import { render, staticRenderFns } from "./kaizhaStatus.vue?vue&type=template&id=00f6d778&scoped=true&"
import script from "./kaizhaStatus.vue?vue&type=script&lang=js&"
export * from "./kaizhaStatus.vue?vue&type=script&lang=js&"
import style0 from "./kaizhaStatus.vue?vue&type=style&index=0&id=00f6d778&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f6d778",
  null
  
)

export default component.exports